import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=84e6912c"
import script from "./TagsSelect.vue?vue&type=script&lang=js"
export * from "./TagsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports